export default "__VITE_PUBLIC_ASSET__a324adf4__"